import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    const addItems = this.element.querySelectorAll('.add-item-button')
    this.dispatch('add-items-count', {
      detail: {
        content: {
          count: addItems.length,
        },
      },
    })
  }
}
